export function initArtistHeader(header, { doc = document, win = window } = {}) {
  if (!header || header.dataset.artistHeaderBound === 'true') return;
  header.dataset.artistHeaderBound = 'true';
  const compact = win.matchMedia('(max-width: 1079px)');
  const items = [...header.querySelectorAll('.he-header__nav-item')];
  const opener = header.querySelector('[data-he-menu-open]');
  const drawer = header.querySelector('[data-he-menu-dialog]');
  const closer = header.querySelector('[data-he-menu-close]');
  let openItem = null;
  let previousOverflow = '';

  const setMenu = (next) => {
    openItem = compact.matches ? null : next;
    items.forEach((item) => {
      const trigger = item.querySelector('[data-he-menu-trigger]');
      const expanded = item === openItem;
      item.classList.toggle('is-open', expanded);
      trigger?.setAttribute('aria-expanded', String(expanded));
    });
    header.classList.toggle('has-open-menu', Boolean(openItem));
  };

  items.forEach((item) => {
    const trigger = item.querySelector('[data-he-menu-trigger]');
    const menu = item.querySelector('.he-header__mega');
    const activate = () => setMenu(trigger && menu ? item : null);
    item.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'touch') activate();
    });
    item.addEventListener('focusin', activate);
    trigger?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown' || compact.matches) return;
      event.preventDefault();
      activate();
      menu.querySelector('a[href], button:not([disabled])')?.focus();
    });
  });
  header.addEventListener('pointerleave', () => setMenu(null));
  header.addEventListener('focusout', (event) => {
    if (!header.contains(event.relatedTarget)) setMenu(null);
  });
  doc.addEventListener('pointerdown', (event) => {
    if (!header.contains(event.target)) setMenu(null);
  });
  doc.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !openItem) return;
    event.preventDefault();
    // Focus first: its focusin may open the menu, then setMenu closes it.
    openItem.querySelector('[data-he-menu-trigger]')?.focus();
    setMenu(null);
  });

  const closeDrawer = () => {
    if (drawer?.open) drawer.close();
  };
  opener?.addEventListener('click', () => {
    if (!drawer || drawer.open) return;
    setMenu(null);
    previousOverflow = doc.body.style.overflow;
    drawer.showModal();
    doc.body.style.overflow = 'hidden';
    opener.setAttribute('aria-expanded', 'true');
  });
  closer?.addEventListener('click', closeDrawer);
  drawer?.addEventListener('click', (event) => {
    // Dismiss before native navigation, including anchors on the current page.
    if (event.target === drawer || event.target.closest?.('a[href]')) closeDrawer();
  });
  // Native dialog supplies focus containment, inert background and Escape.
  drawer?.addEventListener('close', () => {
    doc.body.style.overflow = previousOverflow;
    opener?.setAttribute('aria-expanded', 'false');
    opener?.focus();
  });
  compact.addEventListener('change', () => {
    setMenu(null);
    if (!compact.matches) closeDrawer();
  });
  setMenu(null);
  header.classList.add('is-enhanced');
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-he-artist-header]').forEach((header) => initArtistHeader(header));
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-he-artist-header]').forEach((header) => initArtistHeader(header));
  });
}
